module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control form-search",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n              " + _vm._s(option.label) + "\n            ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship"
  }, [_c('label', [_vm._v("Tipo de operador:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.operatorType),
      expression: "tableData.operatorType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "operatorType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getUsers()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("envío")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("recepción")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.document_number))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.username))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.name) + " " + _vm._s(user.attributes.profile.attributes.surnames))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.city.attributes.name))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [(user.attributes.operator_type === 1) ? _c('span', {
      staticClass: "span-title"
    }, [_vm._v("Envìo")]) : (user.attributes.operator_type === 2) ? _c('span', {
      staticClass: "span-title"
    }, [_vm._v("Recepción")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.country_code) + " " + _vm._s(user.attributes.profile.attributes.cellphone))])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getUsers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9e98be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/user-chart2-list.vue
// module id = 1877
// module chunks = 1